export const newTranslationKey = Symbol("create new translations key")
